import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const macularDegeneration: AnswerPathTreeNode = {
  path: 'macularDegeneration',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredMacularDegenerationDetails }],
};
